import React from 'react';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from '../contexts/AuthContext';
import { ThemeProvider } from './ThemeProvider';
import { CookieConsentProvider } from './CookieConsentProvider';

interface AppProvidersProps {
    children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
    return (
        <ThemeProvider>
            <QueryProvider>
                <AuthProvider>
                    <CookieConsentProvider>
                        {children}
                    </CookieConsentProvider>
                </AuthProvider>
            </QueryProvider>
        </ThemeProvider>
    );
};

export default AppProviders;
